import { createSelector } from 'reselect';

export const getChatContext = createSelector(
  [state => state?.vehicle || {}, state => state?.dashboard || {}],
  (vehicle, dashboard) => ({
    purchase: {
      purchaseId: dashboard?.status?.purchaseId || null,
      vehicle: {
        stockNumber: vehicle?.stockNumber || null,
        vehicleId: vehicle?.vehicleId || null
      }
    }
  })
);

export const getIsMobile = createSelector(
  state => state.ui?.screenSize?.isMobile,
  isMobile => isMobile
);

export const getOrderState = createSelector(
  state => state?.dashboard?.status?.orderState,
  orderState => orderState
);
